import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { TinyAutomationCard } from '../components/TinyAutomationCard';

export function TinyAutomationPage() {
  const authenticatedFetch = useCallback(async (url: string, options: RequestInit = {}) => {
    const token = localStorage.getItem('auth_token');
    const selectedTenantId =
      localStorage.getItem('superadmin_selected_tenant') ||
      localStorage.getItem('selected_tenant_id');
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (token) {
      (headers as Record<string, string>).Authorization = `Bearer ${token}`;
    }

    if (selectedTenantId) {
      (headers as Record<string, string>)['X-Tenant-Id'] = selectedTenantId;
    }

    return fetch(url, {
      ...options,
      headers,
    });
  }, []);

  return (
    <>
      <Header
        title="Envio Automático - Tiny ERP"
        subtitle="Configure regras de envio automático para pedidos do Tiny ERP"
        actions={
          <Link
            to="/tiny-erp"
            className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 text-sm font-medium transition-colors"
            aria-label="Voltar para Tiny ERP"
          >
            ← Voltar
          </Link>
        }
      />

      <div className="p-6">
        <div className="max-w-7xl mx-auto">
          <TinyAutomationCard authenticatedFetch={authenticatedFetch} />
        </div>
      </div>
    </>
  );
}
